import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

export const loginCallbackUri = `com.makeclub.app://makeclub-auth.eu.auth0.com/capacitor/com.makeclub.app/callback`;
export const logoutCallbackUri = `com.makeclub.app://makeclub-auth.eu.auth0.com/capacitor/com.makeclub.app/logout`;

@Component({
  selector: 'mc-root',
  template: ` <router-outlet />`,
  imports: [RouterOutlet],
})
export class Root {
  constructor() {
    // effect(() => {
    //   console.log('Setting up back button handler');
    //   App.addListener('backButton', async ({ canGoBack }) => {
    //     if (this.drawer.isOpen()) {
    //       this.drawer.close();
    //       return;
    //     }
    //     if (canGoBack) {
    //       this.location.back();
    //     } else {
    //       await this.confirmExit();
    //     }
    //   });
    // });
    // effect(() => {
    //   App.addListener('appUrlOpen', async ({ url }) => {
    //     const loginCallback = url?.startsWith(loginCallbackUri);
    //     const logoutCallback = url?.startsWith(logoutCallbackUri);
    //     if (loginCallback) {
    //       if (url.includes('state=') && (url.includes('error=') || url.includes('code='))) {
    //         await firstValueFrom(this.auth.handleRedirectCallback(url));
    //       }
    //       await Browser.close();
    //     }
    //     if (logoutCallback) {
    //       console.log('Root: Detected logout callback URL, closing browser and navigating to home');
    //       await Browser.close();
    //       this.router.navigate(['/']);
    //     }
    //   });
    // });
  }

  // private async confirmExit(): Promise<void> {
  //   const { value } = await Dialog.confirm({
  //     title: 'Salir',
  //     message: '¿Seguro que quieres cerrar la aplicación?',
  //     okButtonTitle: 'Salir',
  //     cancelButtonTitle: 'Cancelar',
  //   });

  //   if (value) await App.exitApp();
  // }
}
